import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/categories')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/category' })
  },
})
